/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

// https://developer.mozilla.org/zh-CN/docs/Web/API/Element/wheel_event
var setTimeout = window.setTimeout;
var TYPE_WHEEL = 'wheel';
var TYPE_WHEEL_START = "".concat(TYPE_WHEEL, "start");
var TYPE_WHEEL_MOVE = "".concat(TYPE_WHEEL, "move");
var TYPE_WHEEL_END = "".concat(TYPE_WHEEL, "end");
/**
 * 统一滚轮的表现
 * 参考: https://github.com/pmndrs/use-gesture/blob/3290c1d5f6beea238afb82c55d48855f10780874/packages/core/src/utils/events.ts#L83
 * @param e 鼠标滚轮事件对象
 * @param LINE_HEIGHT 滚动一行的高度
 * @param PAGE_HEIGHT 滚动一页的高度
 * @returns 一次滚动的偏移
 */
function normalizeWheel(e, LINE_HEIGHT, PAGE_HEIGHT) {
    if (LINE_HEIGHT === void 0) { LINE_HEIGHT = 40; }
    if (PAGE_HEIGHT === void 0) { PAGE_HEIGHT = 800; }
    var deltaX = e.deltaX, deltaY = e.deltaY, deltaMode = e.deltaMode;
    // console.log(deltaMode, e.DOM_DELTA_LINE);
    if (deltaMode == e.DOM_DELTA_LINE) {
        deltaX *= LINE_HEIGHT;
        deltaY *= LINE_HEIGHT;
    }
    else if (deltaMode == e.DOM_DELTA_PAGE) {
        deltaX *= PAGE_HEIGHT;
        deltaY *= PAGE_HEIGHT;
    }
    return [deltaX, deltaY];
}
/**
 * 增强版鼠标滚动事件监听器
 * @param el
 * @param onChange
 * @returns 卸载监听器
 */
function index (el, onChange) {
    // 上一次滚动发生时间
    var _lastWheelTime;
    // wheelend延迟触发的id
    var _endTimeoutId;
    // 一次计算周期的滑动位移
    var _displacementX = 0;
    var _displacementY = 0;
    // 速度
    var velocityX = 0;
    var velocityY = 0;
    var refreshVelocity = throttle(function (timeDiff) {
        velocityX = _displacementX / timeDiff;
        velocityY = _displacementY / timeDiff;
        _displacementX = 0;
        _displacementY = 0;
    }, 16);
    function __onWheel(e) {
        var _a = __read(normalizeWheel(e), 2), deltaX = _a[0], deltaY = _a[1];
        _displacementX += deltaX;
        _displacementY += deltaY;
        /**
         * 触发回调和自定义DOM事件
         * @param type 类型: 'start' | 'move' | 'end'
         */
        function _dispatchEvent(type) {
            var wheelEvent2 = {
                target: e.target,
                deltaX: deltaX,
                deltaY: deltaY,
                type: type,
                velocityX: velocityX,
                velocityY: velocityY,
                nativeEvent: e,
            };
            var event = new Event(TYPE_WHEEL + type);
            onChange(wheelEvent2);
            el.dispatchEvent(event);
        }
        // 刷新速度
        refreshVelocity();
        // 最后一下滚动
        clearTimeout(_endTimeoutId);
        _endTimeoutId = setTimeout(function () {
            _dispatchEvent(TYPE_WHEEL_END);
        }, 166);
        // 开始
        if (void 0 === _lastWheelTime) {
            velocityX = 0;
            velocityY = 0;
            _dispatchEvent(TYPE_WHEEL_START);
        }
        // 移动
        else {
            _dispatchEvent(TYPE_WHEEL_MOVE);
        }
        _lastWheelTime = Date.now();
    }
    el.addEventListener(TYPE_WHEEL, __onWheel);
    return function () {
        el.removeEventListener(TYPE_WHEEL, __onWheel);
    };
}
/**
 * 限流
 * @param callback 回调
 * @param waitTime 等待时间
 * @returns
 */
function throttle(callback, waitTime) {
    // 记录触发时间
    var lastTime = Date.now();
    return function () {
        var now = Date.now();
        var deltaTime = now - lastTime;
        if (deltaTime > waitTime) {
            lastTime = now;
            callback(deltaTime);
        }
    };
}

export { index as default };
